import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

export const TOKEN_NAME = 'accessToken';

export class BaseService {
  protected TOKEN_NAME = TOKEN_NAME;
  protected apiUrl: string = environment.apiUrl;

  constructor(protected http: HttpClient) {
  }

  getHeaders() {
    return {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem(this.TOKEN_NAME)}`
      }
    };
  }

  protected downloadFile(url: string) {
    return this.http.get(url, {
      responseType: 'blob', headers: {
        Authorization: `Bearer ${localStorage.getItem(this.TOKEN_NAME)}`
      }
    });
  }

  protected httpGet<T>(url: string, params: any = null) {
    const paramsValue = params ? `?${Object.keys(params).filter(p => params[p] !== null && params[p] !== undefined).map(p => `${p}=${params[p]}`).join('&')}` : '';
    return this.http.get<T>(`${this.apiUrl}${url}${paramsValue}`, this.getHeaders());
  }

  protected httpPost<T>(url: string, data?: any) {
    return this.http.post<T>(`${this.apiUrl}${url}`, data, this.getHeaders());
  }

  protected httpPut<T>(url: string, data: any) {
    return this.http.put<T>(`${this.apiUrl}${url}`, data, this.getHeaders());
  }

  protected httpPatch<T>(url: string, data?: any) {
    return this.http.patch<T>(`${this.apiUrl}${url}`, data, this.getHeaders());
  }

  protected httpDelete<T>(url: string) {
    return this.http.delete<T>(`${this.apiUrl}${url}`, this.getHeaders());
  }

}
